import { getUniversalCookie, setUniversalCookie } from '@/cookies';
import { generateUUID } from '@/lib/utils';

const META_EVENT_ID_COOKIE = '_meta_event_id';
const META_EVENT_ID_MAX_AGE = 60 * 60 * 24 * 90;

const setMetaEventIdCookie = (eventId: string): void => {
  setUniversalCookie(META_EVENT_ID_COOKIE, eventId, {
    options: { maxAge: META_EVENT_ID_MAX_AGE },
  });
};

export const getMetaEventId = (): string => {
  const existing = getUniversalCookie<string>(META_EVENT_ID_COOKIE);

  if (existing) {
    return existing;
  }

  const eventId = generateUUID();

  setMetaEventIdCookie(eventId);

  return eventId;
};

export const refreshMetaEventId = (): string => {
  const eventId = generateUUID();

  setMetaEventIdCookie(eventId);

  return eventId;
};
